<style scoped>
.invalid-feedback {
  display:block
}
.bilgi{
    margin-top:10px
}
</style>
<script>
import { notify } from '@/helpers/notify' 

export default {
    name:'CreateAddForm',
    props:[
        "formData"
    ],
    data() {
        return {
            form:{},
            submitted: false,
            ip_check:true,
            ilList : [],
            ipList : [],
            userList: [],
            bucakList:[],
            tariffList : [],
            list:{
                'fullname' : ["fname","lname"]
            }
        };
    },
    mounted() {
        this.form = this.formData
        if(this.form.type == 'contact'){
            this.setSelected({ id : 0},'il')
        }
        if(this.form.type == 'service'){
            this.getTariffList()
        }
        if(this.form.type == 'dealer'){
            this.getUserList()
        }
        if(this.form.type == 'network'){
            this.getStaticIpList('s')
        }
    },
    methods: { 
        ipKindChange({ target }){
              this.getStaticIpList(target.checked ? 's' : 'l')
        },
        save(){
            this.submitted = true;

            this.$http.put(`members/kb_update`, { ...this.form })
                        .then((resp) => notify.success(resp.data.message))
                        .catch(error => error)
            this.submitted = false;
        },
        getStaticIpList(type){
            this.$http.post('/ips/getByRouterId', { type })
            .then(resp => {
                this.ipList = resp.data.content
            })
            .catch(error => error)
        },
        showSection(section){
            if( !this.form.type ) return true

            let type = this.form.type
            if(type.indexOf(",")){
                type = type.split(',')
            }

            return type.includes(section)
        }, 
        showUpdate(){
            return (this.form && this.form.hasOwnProperty('type')) || this.$route.name == "on-kayit-ekle" 
        }, 
        async getTariffList(){
            await this.$http.post('/tariff?output=one&fields=id,name')
            .then(resp => {
                this.tariffList = resp.data
            })
            .catch(error => error)
        },
        async getUserList(){
            await this.$http.post('/users?output=one&fields=id,name')
            .then(resp => { this.userList = resp.data })
            .catch(error => error)
        },
        async setSelected(val,event){
            const object = event + 'List' 
            const { id } = val
            const response = await this.$http.post(`/address/${event}/${id}`)
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
            if(response.data.error) return;
            this[object] = response.data;
        },
    },
};
</script>

<template>  
<form class="needs-validation">
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('fullname')"> 
        <label class="col-sm-3 col-form-label col-form-label" for="isim">İsim</label>
        <div class="col" v-if="showUpdate()">
            <input
            id="identity_name"
            v-model="form.fname"
            type="text"
            class="form-control"
            placeholder="İsim"
            />
        </div>
        <div class="col bilgi" v-else>
            {{ form.fname }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('fullname')">
        <label class="col-sm-3 col-form-label col-form-label" for="Soyisim">Soyisim</label>
        <div class="col" v-if="showUpdate()">
            <input
            id="identity_last"
            v-model="form.lname"
            type="text"
            class="form-control"
            placeholder="Soyisim"
            />
        </div>
        <div class="col bilgi" v-else>
            {{ form.lname }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('contact')">
        <label class="col-sm-3 col-form-label col-form-label" for="phonenumber">Ev Telefon</label>
        <div class="col" v-if="showUpdate()">
            <input
                id="phonenumber"
                v-model="form.phonenumber"
                type="text"
                v-mask="'+(##)### ### ## ##'"
                class="form-control"
                placeholder="Telefon"
            />
        </div>
        <div class="col bilgi" v-else>
            {{ form.phonenumber }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('contact')">
        <label class="col-sm-3 col-form-label col-form-label" for="phonenumber2">Cep Telefon</label>
        <div class="col" v-if="showUpdate()">
            <input
                id="phonenumber2"
                v-model="form.phonenumber2"
                type="text"
                v-mask="'+(##)### ### ## ##'"
                class="form-control"
                placeholder="Cep Telefon"
            />
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.phonenumber2 }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1"  v-if="showSection('contact')">
        <label class="col-sm-3 col-form-label col-form-label" for="email">E-Posta</label>
        <div class="col" v-if="showUpdate()">
            <input
            id="email"
            v-model="form.email"
            type="text"
            class="form-control"
            placeholder="E-Posta"
            />
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.email }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1"  v-if="showSection('contact')">
        <label class="col-sm-3 col-form-label col-form-label" for="il">İlçe</label>
        <div class="col" v-if="showUpdate()">
            <v-select
                label="name" 
                v-model="form.province"
                :options="ilList" 
                :reduce="country => country.id"
                @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.prvince }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1"  v-if="showSection('contact')">
        <label class="col-sm-3 col-form-label col-form-label" for="bolge">Bölge</label>
        <div class="col" v-if="showUpdate()">
            <v-select 
            label="name"  
            v-model="form.township"                    
            :options="bucakList" 
            :reduce="country => country.id"
            @option:selecting="setSelected($event,'koy')"><span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.township }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1"  v-if="showSection('contact')">
        <label class="col-sm-3 col-form-label col-form-label" for="adress">Adres</label>
        <div class="col" v-if="showUpdate()">
            <input
                id="adress" 
                v-model="form.address"
                type="text"
                class="form-control"
                placeholder="Adres Açıklaması"
            />
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.address }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('service')">
        <label class="col-sm-3 col-form-label col-form-label" for="service">Servis</label>
        <div class="col" v-if="showUpdate()">
            <v-select 
                v-model="form.tariff_id"
                :options="tariffList"
                :reduce="r => r.id"
                label="name"
                >
            <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
        <div class="col bilgi" v-else>
            {{ form.tariff_name }}
        </div> 
    </div>
    <div class="row d-flex flex-wrap mb-1"  v-if="showSection('password')">
        <label class="col-sm-3 col-form-label col-form-label" for="password">Şifre</label>
        <div class="col" v-if="showUpdate()">
            <input
                id="password" 
                v-model="form.password"
                type="text"
                class="form-control"
                placeholder="Şifre"
            />
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.password }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('expiredate')">
        <label class="col-sm-3 col-form-label col-form-label" for="expiredate">Bitiş Tarihi</label>
        <div class="col" v-if="showUpdate('expiredate')">
            <input
                id="expiredate" 
                v-model="form.expiredate"
                type="datetime-local"
                class="form-control"
            />
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.expiredate }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('dealer')">
        <label class="col-sm-3 col-form-label col-form-label" for="dealer">Bayi</label>
        <div class="col" v-if="showUpdate('dealer')">
           <v-select 
                v-model="form.user_id"
                :options="userList"
                :reduce="r => r.id"
                label="name"
                >
            <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
        
        <div class="col bilgi" v-else>
            {{ form.expiredate }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('ppoe')">
        <label class="col-sm-3 col-form-label col-form-label">Kullanıcı Adı</label>
        <div class="col bilgi">
            {{ form.username }}
        </div>
    </div>
     <div class="row d-flex flex-wrap mb-1" v-if="showSection('ppoe')">
        <label class="col-sm-3 col-form-label col-form-label">Kullanıcı Şifre</label>
        <div class="col bilgi">
            {{ form.password }}
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('network')"> 
        <div class="col" v-if="showUpdate()">
            <label class="col-sm-3 col-form-label col-form-label" for="ip_check">Statik İp</label>
            <input type="checkbox" id="ip_check" v-model="ip_check" @change="ipKindChange($event)" />
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="showSection('network')"> 
        <label class="col-sm-3 col-form-label col-form-label" for="ip">İp</label>
        <div class="col" v-if="showUpdate()">
            <v-select 
                    v-model="form.ip_id"
                    :options="ipList"
                    :reduce="r => r.id"
                    label="ip"
                    >
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                        {{ option.ip }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                        {{ option.ip }}
                        </div>
                    </template>
                <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
        <div class="col bilgi" v-else>
            {{ form.static_ip }}
        </div>
    </div>
     <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" @click="$emit('close')">Vazgeç</b-button>
        <button class="btn btn-primary" type="button" @click="save()" v-if="form.id" >Güncelle</button>
        <button class="btn btn-secondary" type="button" @click="$emit('close')" v-else >Kapat</button>
    </div>
</form>
<!-- end card -->
</template>